import { render, staticRenderFns } from "./RelatedOptions.vue?vue&type=template&id=3cce4f32"
import script from "./RelatedOptions.vue?vue&type=script&lang=js"
export * from "./RelatedOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports